import * as React from "react";
import ProjectDetails from "./ProjectDetails";
const galleryImages = [{
  id: 1,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20210712_143147-scaled.jpg?v=tzrh3wfdd",
  alt: "Pareklisia residence exterior view"
}, {
  id: 2,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20210712_143203-scaled.jpg?v=bvewrorof14",
  alt: "Interior living room renovation"
}, {
  id: 3,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20210712_143214-scaled.jpg?v=ck8hinzoz2k",
  alt: "Modern kitchen remodel"
}, {
  id: 4,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20210712_144212-scaled.jpg?v=5p0kequ93al",
  alt: "Master bedroom interior design"
}, {
  id: 5,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG_20210712_144240-scaled.jpg?v=45tuix58nrc",
  alt: "Luxury bathroom renovation"
}, {
  id: 6,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/IMG-92e6fb7f021cd32882de760c63e85654-V.jpg?v=l6ds4rie1ps",
  alt: "Outdoor terrace and garden"
}];
export default function ProjectHeroImage() {
  return <section id="project-hero-image" className="bg-[#fff] py-12">
      <div className="w-full px-8 max-w-[1920px] mx-auto">
        <h1 className="text-center font-bold mb-10 !text-[27px]">Pareklisia Residence Renovation</h1>
        <ProjectDetails />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="overflow-hidden rounded-[0.5rem] bg-muted/20">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover aspect-[4/3] transition-transform duration-500 hover:scale-105" loading={i < 3 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}